// @flow
import * as React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import { momentFromDateString } from "data/units/date/helpers"
import type { Reservation } from "data/reservations/types"
import { PageTitle } from "componentsStyled/Typography/Titles"

type Props = {
  extendedReservation: Reservation,
}

const ExtendReservationConfirm = ({ extendedReservation }: Props) => {
  const displayName = extendedReservation.productItem.productVariant.product.productGroup.name

  return (
    <React.Fragment>
      <PageTitle>Extension Confirmed!</PageTitle>
      <Text book black center lh={2}>
        You're ready to go
      </Text>
      <Text center>
        You now have your {displayName} until{" "}
        {momentFromDateString(extendedReservation.end).format("MMM D")}
      </Text>
    </React.Fragment>
  )
}

export default ExtendReservationConfirm



// WEBPACK FOOTER //
// ./src/pages/Reservation/ExtendReservationConfirm/index.js